import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Region, RegionStatus } from '../models/region.model';

export type { Region as RegistryRegion, RegionStatus };

export interface RegistryRegionsResponse {
  regions: Region[];
}

/**
 * Super-admin API for the address registry's region catalog (see
 * backend/src/routes/admin-registry.ts). Distinct from the public, non-admin
 * GET /api/regions the map itself reads — this one is for the build-status page and its
 * polling cadence.
 */
@Injectable({ providedIn: 'root' })
export class AdminRegistryService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getRegions(): Observable<RegistryRegionsResponse> {
    return this.http.get<RegistryRegionsResponse>(`${this.apiUrl}/admin/regions`);
  }

  buildRegion(slug: string): Observable<{ region: Region }> {
    return this.http.post<{ region: Region }>(`${this.apiUrl}/admin/regions/${slug}/build`, {});
  }
}
